import {
  Component,
  Input,
  OnDestroy,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { HorizontalAlignment } from '../types';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'wfm-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnDestroy, AfterContentInit {
  @Input() multiple: boolean;

  @Input() caretsOnRight: boolean;

  @Input() caretsAlignment: HorizontalAlignment = HorizontalAlignment.left;

  @Output() selectionChange = new EventEmitter<number[]>();

  @Input() filled: boolean;

  @ContentChildren(AccordionItemComponent) items: QueryList<AccordionItemComponent>;

  private subscriptions: Subscription[] = [];

  private window: Window;

  constructor(@Inject(DOCUMENT) private document: any) {
    this.window = (this.document as Document).defaultView;
  }

  ngAfterContentInit() {
    if (this.caretsOnRight != undefined) {
      this.items.forEach(item => {
        item.caretsOnRight = this.caretsOnRight;
      });
    }
    if (this.filled != undefined) {
      this.items.forEach(item => {
        item.filled = this.filled;
      });
    }
    this.items.changes.subscribe(() => this.refreshItems());
    this.refreshItems();
  }

  private refreshItems() {
    this.window.setTimeout(() => {
      this.unsubscribe();

      this.items.toArray().forEach((item, index) => {
        item.id = index;
        this.subscriptions.push(item.selectedChange.subscribe(() => this.itemSelectedChange(item)));
      });
    }, 0);
  }

  private unsubscribe() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }

  private itemSelectedChange(item: AccordionItemComponent) {
    if (!this.multiple && item.selected) {
      this.items.forEach(i => i !== item && i.close());
    }

    this.selectionChange.emit(this.items.filter(i => i.selected).map(i => i.id));
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
